import React from "react";
import { useRouteMatch } from "react-router-dom";

const ListItem = ({ item }) => {
	const {
		params: { houseId },
	} = useRouteMatch("/Meters/address/:houseId") || { params: {} };
	return (
		<div
			className={`list-item ${
				Number(houseId) === item.id ? "list-item-active" : ""
			}`}
		>
			<div className="header">{item.streetName || item.addressName}</div>
			<div className="company-name">{item.serviceCompanyName}</div>
		</div>
	);
};

export default ListItem;
